import React, { useState } from "react";

import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Tooltip } from "antd";
import SportsScoreIcon from "@mui/icons-material/SportsScore";
import { makeStyles } from "tss-react/mui";

import CollapseCell from "./CollapseCell";
import ComponentAvatar from "./ComponentAvatar";

const useStyles = makeStyles()((theme) => ({
  tr: {
    "& td, & th": {
      wordBreak: "break-word",
    },
    "&:nth-of-type(odd)": {
      backgroundColor: "#ffffff",

      "& td:first-child": {
        backgroundColor: "#ffffff",
      },
    },
    "&:nth-of-type(even)": {
      "& td:first-child": {
        backgroundColor: "white",
      },
    },
  },
}));

const DataTableRow = ({ row, collapseOpen, setCollapseOpen }) => {
  const { classes } = useStyles();
  const [rule, setRule] = useState("");
  return (
    <>
      <TableRow tabIndex={-1} key={row.ID} hover className={classes.tr}>
        <>
          <TableCell component="th" scope="row" padding="normal">
            <Box display="flex">
              <Tooltip placement="right" title={row.ModuleType}>
                <>
                  <ComponentAvatar componentType={row.ModuleType} />
                </>
              </Tooltip>
              {row.Name}
            </Box>
          </TableCell>
          <TableCell component="th" scope="row" padding="normal">
            {row.FieldName}
          </TableCell>
          <TableCell component="th" scope="row" padding="normal">
            <Grid container spacing={1}>
              {row?.DQM && (
                <Grid>
                  <Chip
                    color="info"
                    size="small"
                    style={{ cursor: "pointer", backgroundColor: "#EEB680", width: "80px" }}
                    icon={<SportsScoreIcon fontSize="12px" />}
                    label="DQM"
                    onClick={() => {
                      setRule("DQM");
                      setCollapseOpen((prev) => {
                        return {
                          id: row.ID,
                          open: row.ID === prev.id ? !prev.open : true,
                        };
                      });
                    }}
                  />
                </Grid>
              )}
              {row?.MDM && (
                <Grid>
                  <Chip
                    label="MDM"
                    size="small"
                    variant="filled"
                    color="info"
                    icon={<img src="/images/database_chip.png" height="12px" alt="mdm" />}
                    style={{ cursor: "pointer", width: "80px" }}
                    onClick={() => {
                      setRule("MDM");
                      setCollapseOpen((prev) => {
                        return {
                          id: row.ID,
                          open: row.ID === prev.id ? !prev.open : true,
                        };
                      });
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </TableCell>
        </>
      </TableRow>
      <TableRow style={{ backgroundColor: "#f5f5f5" }}>
        <CollapseCell contentID={row.ID} collapseOpen={collapseOpen} innerContent={false} />
        <CollapseCell contentID={row.ID} collapseOpen={collapseOpen} innerContent={false} />
        <CollapseCell contentID={row.ID} collapseOpen={collapseOpen} innerContent={row[rule]} Rule={rule} />
      </TableRow>
    </>
  );
};

export default React.memo(DataTableRow);
